<template>
  <section class="admin-content" id="contact-search">
    <Navbar />
    <main class="admin-main">
      <div class="bg-info m-b-30">
        <div class="container">
          <div class="row p-b-60 p-t-60">
            <div class="col-md-6 text-center mx-auto text-dark p-b-30">
              <h3 class="h3">Claims</h3>
            </div>
          </div>
        </div>
      </div>
      <section class="pull-up">
        <div class="container">
          <div class="row list">
            <div class="col-lg-12 col-md-12">
              <div class="card m-b-30">
                <div class="card-body">
                  <div class="col-md-12">
                    <div class="row">
                      <div class="form-group col-md-4">
                        <p><label for="inputPassword4">Date of Care</label></p>

                        <input
                          type="date"
                          class="form-control"
                          v-model="claim.seen_date"
                        />
                      </div>

                      <div class="form-group col-md-6">
                        <label for="inputPassword4">Select Provider
                        <button class="btn btn-outline-info btn-sm"
                        @click="getProviders"
                        >Get</button>  
                        </label>
                        <v-select
                          v-model="claim.provider"
                          :reduce="(agency_name) => agency_name.id"
                          label="agency_name"
                          :options="providers"
                        />
                      </div>

                      <div class="form-group col-md-4">
                        <label for="inputCity"
                          >Select Staff

                          <button
                            @click="getEmployees"
                            class="btn btn-outline-info btn-small"
                          >
                            Get Staff
                          </button>
                        </label>

                        <select
                          class="form-control"
                          required
                          v-model="claim.staff"
                        >
                          <option
                            v-for="staff in staffs"
                            :key="staff.id"
                            :value="staff.id"
                          >
                            {{ staff.full_name }}
                          </option>
                        </select>
                      </div>

                      <div class="form-group col-md-4">
                        <label for="inputCity">Enrollee ID </label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="client"
                          @change="searchIDCard"
                        />
                      </div>

                      <div class="row col-md-12" v-if="search_result">
                        <div class="form-group col-md-6">
                          <label for="inputCity">Enrollee Name</label>
                          <input
                            type="text"
                            class="form-control"
                            id="inputEmail4"
                            :value="search_result.data[0].full_name"
                            disabled
                          />
                        </div>
                      </div>

                      <div class="form-group col-md-6">
                        <label for="inputPassword4">Select Diagnosis </label>
                        <v-select
                          v-model="claim.diagnosis"
                          :reduce="(name) => name.id"
                          label="name"
                          :options="diseases"
                        />
                      </div>
                    </div>

                    <div class="form-group col-md-12">
                      <label for="inputAddress">Reason for Claim</label>

                      <v-select
                        v-model="claim.treatment"
                        label="name"
                        :options="reasons"
                      />

                     
                    </div>
                  </div>

                  <div class="form-group mt-4">
                    <button
                      class="btn btn-outline-info btn-block"
                      @click="makeClaim"
                    >
                      Proceed to Drugs/Service Processing
                      <i class="fe fe-chevron-right"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="vld-parent">
          <loading
            :active.sync="isLoading"
            loader="dots"
            :can-cancel="true"
            :is-full-page="fullPage"
          ></loading>
        </div>
      </section>
    </main>
  </section>
</template>
  
  <script>
import Navbar from "@/views/Navbar.vue";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  components: {
    Navbar,
    Loading,
  },
  data() {
    return {
      user: null,
      client: "",
      providers: "",
      staffs: "",
      claims: "",
      diseases: "",
      searchkey: "",
      search_result: "",
      enrollee_details: "",
      edit: false,
      isLoading: false,
      fullPage: true,
      claim: {
        staff: "",
        provider: "",
        client_id: "",
        dependent_id: "",
        diagnosis: "",
        treatment: "",
        is_out_of_station: false,
        client_name: "",
        seen_date: "",
      },
      reasons: [
        "Medical treatment for an illness or injury",
        "Prescription medications",
        "Diagnostic tests and screenings",
        "Surgical procedures",
        "Physical therapy or rehabilitation",
        "Mental health counseling or therapy",
        "Medical equipment or supplies",
        "Home health care",
        "Dental or vision care",
        "Emergency room visits",
        "Hospitalization",
        "Maternity care",
        "Preventive care services",
        "Specialist consultations",
        "Out-of-network provider services",
        "Ambulance services",
        "Hospice care",
        "Chiropractic care",
        "Occupational therapy",
        "Speech therapy",
        "Others",
      ],
    };
  },
  beforeMount() {
    this.user = JSON.parse(localStorage.getItem("user"));
  },
  computed: {},
  methods: {
    getProviders() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .get(`/api/v1/auth/providerAgency/384556`)
        .then((response) => {
          this.providers = response.data.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    getEmployees() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .get(`/api/v1/auth/getEmployee/${this.claim.provider}`)
        .then((response) => {
          this.staffs = response.data.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    getDiseases() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .get(`/api/v1/auth/diagnosis-agency/95930`)
        .then((response) => {
          this.diseases = response.data.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    searchIDCard() {
      this.isLoading = true;
      this.axios
        .post(`/api/v1/auth/getuserbyIdcard`, {
          id_card_number: this.client,
        })
        .then((response) => {
          this.search_result = response.data;
          console.log(response);
          this.$toasted.info("Searched Successfully", {
            position: "top-center",
            duration: 3000,
          });

          this.isLoading = false;
        })
        .catch((error) => {
          console.error(error);
          this.isLoading = false;
          this.$toasted.error("User not Found", {
            position: "top-center",
            duration: 3000,
          });
        });
    },
    makeClaim() {
      // Add claim
      this.isLoading = true;
      this.axios
        .post("/api/v1/auth/claims", {
          provider_id: this.claim.provider,
          user_id: this.claim.staff,
          agency_id: 384556,
          client_name:
            this.search_result.type == "client"
              ? this.search_result.data[0].id
              : 0,
          dependent_id:
            this.search_result.type == "dependent"
              ? this.search_result.data[0].id
              : 0,
          seen_date: this.claim.seen_date,
          diagnosis: this.claim.diagnosis,
          treatment: this.claim.treatment,
          authorization_code: this.claim.authorization_code,
          is_out_of_station: this.claim.is_out_of_station,
        })

        .then((response) => {
          console.log(response);
          let id = response.data.id;
          this.isLoading = false;
          this.$router.push(`/service-processing-form/${id}`);
        })
        .catch((error) => {
          console.log(error.response);
        });
    },
  },
  created() {
    this.getDiseases();
    this.getProviders();
  },
};
</script>
  